import React from 'react';
import { Alert, Box, Notification } from '@wix/cli-ui-kit';
import { ComponentType } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { useExtensions } from '../../extensions/useExtensions.js';

// This Warning is relevant only to Webhooks, this is because webhook is not a real extension.
// This is the only entity that will be updated the moment user _commit_ changes to the DC.
// The change will be _immediately_ propagated to all versions.
export const Warnings = () => {
  const { getExtensions } = useExtensions();

  if (getExtensions(ComponentType.WEBHOOK).length === 0) {
    return null;
  }

  return (
    <Box flexDirection="column" paddingBottom={1}>
      <Notification>
        <Alert type="warning">
          Your project includes backend events. Once you proceed, any changes to
          events will be immediately deployed to production and take effect
          automatically, even without a new version release.
        </Alert>
      </Notification>
    </Box>
  );
};
